import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _css;
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css } from '@emotion/react';
import { blanketSelectionStyles, boxShadowSelectionStyles, dangerBackgroundStyles, dangerBorderStyles, hideNativeBrowserTextSelectionStyles } from './selectionStyles';
var akEditorLineHeight = 1.714;
var akEditorSelectedNodeClassName = 'ak-editor-selected-node';
export var TaskDecisionSharedCssClassName = {
  DECISION_CONTAINER: 'decisionItemView-content-wrap',
  TASK_CONTAINER: 'taskItemView-content-wrap',
  TASK_ITEM: 'task-item',
  TASK_CHECKBOX_CONTAINER: 'task-item-checkbox-wrap'
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var tasksAndDecisionsStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ProseMirror': _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ".taskItemView-content-wrap, .".concat(TaskDecisionSharedCssClassName.DECISION_CONTAINER), {
    position: 'relative',
    minWidth: 48
  }), ".".concat(TaskDecisionSharedCssClassName.DECISION_CONTAINER), {
    marginTop: 0
  }), ".".concat(TaskDecisionSharedCssClassName.TASK_CONTAINER), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "span[contenteditable='false']": {
      height: "".concat(akEditorLineHeight, "em")
    }
  }), ".".concat(TaskDecisionSharedCssClassName.TASK_ITEM), {
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: akEditorLineHeight
  }),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  'div[data-task-local-id]': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "span[contenteditable='false']": {
      height: "".concat(akEditorLineHeight, "em")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "span[contenteditable='false'] + div": {
      // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
      lineHeight: "".concat(akEditorLineHeight, "em")
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  'div[data-task-list-local-id]': {
    margin: "var(--ds-space-150, 12px)".concat(" 0 0 0"),
    // If task item is not first in the list then set margin top to 4px.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div + div': {
      marginTop: "var(--ds-space-050, 4px)"
    }
  },
  // If task list is not first in the document then set margin top to 4px.
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  'div[data-task-list-local-id] div[data-task-list-local-id]': {
    marginTop: "var(--ds-space-050, 4px)",
    marginLeft: "var(--ds-space-300, 24px)"
  },
  // When action list is inside panel
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ak-editor-panel__content': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
    '> div[data-task-list-local-id]:first-child': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
      margin: '0 !important'
    }
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var decisionStyles = css((_css = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_css, ".".concat(akEditorSelectedNodeClassName, " > [data-decision-wrapper], ol[data-node-type='decisionList'].").concat(akEditorSelectedNodeClassName),
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
[{
  borderRadius: "var(--ds-radius-small, 4px)"
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
boxShadowSelectionStyles,
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
blanketSelectionStyles,
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
hideNativeBrowserTextSelectionStyles]), '.danger', _defineProperty({}, ".".concat(TaskDecisionSharedCssClassName.DECISION_CONTAINER, ".").concat(akEditorSelectedNodeClassName, " > div"), {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
  boxShadow: "0 0 0 1px ".concat("var(--ds-border-danger, #E2483D)"),
  backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
  '&::after': {
    content: 'none' // reset the Blanket selection style
  }
})), '[data-prosemirror-node-name="decisionItem"]', {
  listStyleType: 'none'
}), '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper]', {
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'row',
  margin: "var(--ds-space-100, 8px)".concat(" 0 0 0"),
  padding: "var(--ds-space-100, 8px)",
  paddingLeft: "var(--ds-space-150, 12px)",
  borderRadius: "var(--ds-radius-small, 4px)",
  backgroundColor: "var(--ds-background-neutral, #091E420F)",
  position: 'relative'
}), '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"]', {
  flex: '0 0 16px',
  height: '16px',
  width: '16px',
  margin: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-150, 12px)", " 0 0"),
  color: "var(--ds-icon-subtle, #626F86)",
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}), '[data-prosemirror-node-name="decisionItem"]:not(:has([data-empty]):not(:has([data-type-ahead]))) > [data-decision-wrapper] > [data-component="icon"]', {
  color: "var(--ds-icon-success, #22A06B)"
}), '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span', {
  display: 'inline-block',
  flexShrink: 0,
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- Mirroring icon styles
  lineHeight: 1
}), '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span > svg', {
  overflow: 'hidden',
  pointerEvents: 'none',
  color: 'currentColor',
  verticalAlign: 'bottom'
}), '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="placeholder"]', {
  margin: "0 0 0 calc(".concat("var(--ds-space-100, 8px)", " * 3.5)"),
  position: 'absolute',
  color: "var(--ds-text-subtlest, #626F86)",
  pointerEvents: 'none',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  maxWidth: 'calc(100% - 50px)'
}), '[data-prosemirror-node-name="decisionItem"]:not(:has([data-empty]):not(:has([data-type-ahead]))) > [data-decision-wrapper] > [data-component="placeholder"]', {
  display: 'none'
}), _defineProperty(_css, '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="content"]', {
  margin: 0,
  wordWrap: 'break-word',
  minWidth: 0,
  flex: '1 1 auto'
})));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var decisionDangerStyles = css(_defineProperty({}, ".".concat(akEditorSelectedNodeClassName, ".danger > [data-decision-wrapper], ol[data-node-type='decisionList'].").concat(akEditorSelectedNodeClassName, ".danger"),
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
[dangerBackgroundStyles, dangerBorderStyles]));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var decisionIconWithVisualRefresh = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span >  svg[data-icon-source="legacy"]': {
    display: 'none'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span': {
    boxSizing: 'border-box',
    paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
    paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)',
    '@media screen and (forced-colors: active)': {
      color: 'canvastext',
      filter: 'grayscale(1)'
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span > svg': {
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)"
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var decisionIconWithoutVisualRefresh = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span >  svg[data-icon-source="refreshed"]': {
    display: 'none'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span': {
    width: '32px',
    height: '32px',
    '@media screen and (forced-colors: active)': {
      filter: 'grayscale(1)',
      color: 'canvastext',
      fill: 'canvas'
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span > svg': {
    maxWidth: '100%',
    maxHeight: '100%',
    fill: "var(--ds-surface, #FFFFFF)",
    width: '32px',
    height: '32px'
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var taskItemStyles = css(_defineProperty({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="taskItem"]': {
    listStyle: 'none'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="taskItem"] [data-component="task-item-main"]': {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="taskItem"] [data-component="placeholder"]': {
    position: 'absolute',
    color: "var(--ds-text-subtlest, #626F86)",
    margin: "0 0 0 calc(".concat("var(--ds-space-100, 8px)", " * 3)"),
    pointerEvents: 'none',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    maxWidth: 'calc(100% - 50px)',
    display: 'none'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
  "[data-prosemirror-node-name='taskItem']:has([data-empty]):not(:has([data-type-ahead])) [data-component='placeholder']": {
    display: 'block'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="taskItem"] [data-component="content"]': {
    margin: 0,
    wordWrap: 'break-word',
    minWidth: 0,
    flex: '1 1 auto'
  },
  // copied styles from packages/design-system/icon/src/components/icon-new.tsx
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="taskItem"] [data-component="checkbox-icon-wrap"]': {
    display: 'inline-block',
    boxSizing: 'border-box',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
    paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="taskItem"] [data-component="checkbox-icon-wrap"] svg': {
    overflow: 'hidden',
    pointerEvents: 'none',
    color: 'currentColor',
    verticalAlign: 'bottom',
    width: "var(--ds-space-200, 16px)",
    height: "var(--ds-space-200, 16px)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
  '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-checked-icon]': {
    display: 'none'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
  '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-unchecked-icon]': {
    display: 'inline'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:checked + span [data-component=checkbox-checked-icon]': {
    display: 'inline'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:checked + span [data-component=checkbox-unchecked-icon]': {
    display: 'none'
  }
}, "[data-prosemirror-node-name=\"taskItem\"] .".concat(TaskDecisionSharedCssClassName.TASK_CHECKBOX_CONTAINER), {
  flex: '0 0 24px',
  width: '24px',
  height: '24px',
  position: 'relative',
  alignSelf: 'start',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  "& > input[type='checkbox']": {
    width: '16px',
    height: '16px',
    zIndex: 1,
    cursor: 'pointer',
    outline: 'none',
    margin: 0,
    opacity: 0,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[disabled]': {
      cursor: 'default'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '+ span': {
      width: '24px',
      height: '24px',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '+ span > svg': {
      boxSizing: 'border-box',
      display: 'inline',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      maxWidth: 'unset',
      maxHeight: 'unset',
      position: 'absolute',
      overflow: 'hidden',
      color: "var(--ds-background-input, #FFFFFF)",
      transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
      'path:first-of-type': {
        visibility: 'hidden'
      },
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
      'rect:first-of-type': {
        stroke: "var(--ds-border-input, #8590A2)",
        strokeWidth: 1,
        transition: 'stroke 0.2s ease-in-out'
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&:hover + span > svg': {
      color: "var(--ds-background-input-hovered, #F7F8F9)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
      'rect:first-of-type': {
        stroke: "var(--ds-border-input, #8590A2)"
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&:checked:hover + span > svg': {
      color: "var(--ds-background-selected-bold-hovered, #0055CC)",
      fill: "var(--ds-icon-inverse, #FFFFFF)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
      'rect:first-of-type': {
        stroke: "var(--ds-background-selected-bold-hovered, #0055CC)"
      }
    },
    '&:checked': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
      '+ span > svg': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'path:first-of-type': {
          visibility: 'visible'
        },
        color: "var(--ds-background-selected-bold, #0C66E4)",
        fill: "var(--ds-icon-inverse, #FFFFFF)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
          stroke: "var(--ds-background-selected-bold, #0C66E4)"
        }
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + span > svg': {
      color: "var(--ds-background-input-pressed, #FFFFFF)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
      'rect:first-of-type': {
        stroke: "var(--ds-border, #091E4224)"
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + span > svg': {
      color: "var(--ds-background-input-pressed, #FFFFFF)",
      fill: "var(--ds-icon-inverse, #FFFFFF)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
      'rect:first-of-type': {
        stroke: "var(--ds-border, #091E4224)"
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + span > svg, &:disabled:hover + span > svg, &:disabled:focus + span > svg, &:disabled:active + span > svg': {
      color: "var(--ds-background-disabled, #091E4208)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
      'rect:first-of-type': {
        stroke: "var(--ds-background-disabled, #091E4208)"
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + span > svg': {
      fill: "var(--ds-icon-disabled, #091E424F)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:focus + span::after': {
      position: 'absolute',
      width: "var(--ds-space-200, 16px)",
      height: "var(--ds-space-200, 16px)",
      border: "2px solid ".concat("var(--ds-border-focused, #388BFF)"),
      borderRadius: "var(--ds-space-050, 4px)",
      content: "''",
      display: 'block',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }
  }
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var taskItemStylesWithBlockTaskItem = css(_defineProperty({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="taskItem"], [data-prosemirror-node-name="blockTaskItem"]': {
    listStyle: 'none'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="taskItem"] [data-component="task-item-main"], [data-prosemirror-node-name="blockTaskItem"] [data-component="task-item-main"]': {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="taskItem"] [data-component="placeholder"], [data-prosemirror-node-name="blockTaskItem"] [data-component="placeholder"]': {
    position: 'absolute',
    color: "var(--ds-text-subtlest, #626F86)",
    margin: "0 0 0 calc(".concat("var(--ds-space-100, 8px)", " * 3)"),
    pointerEvents: 'none',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    maxWidth: 'calc(100% - 50px)',
    display: 'none'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
  "[data-prosemirror-node-name='taskItem']:has([data-empty]):not(:has([data-type-ahead])) [data-component='placeholder'], [data-prosemirror-node-name='blockTaskItem']:has([data-empty]):not(:has([data-type-ahead])) [data-component='placeholder']": {
    display: 'block'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="taskItem"] [data-component="content"], [data-prosemirror-node-name="blockTaskItem"] [data-component="content"]': {
    margin: 0,
    wordWrap: 'break-word',
    minWidth: 0,
    flex: '1 1 auto'
  },
  // copied styles from packages/design-system/icon/src/components/icon-new.tsx
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="taskItem"] [data-component="checkbox-icon-wrap"], [data-prosemirror-node-name="blockTaskItem"] [data-component="checkbox-icon-wrap"]': {
    display: 'inline-block',
    boxSizing: 'border-box',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
    paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="taskItem"] [data-component="checkbox-icon-wrap"] svg, [data-prosemirror-node-name="blockTaskItem"] [data-component="checkbox-icon-wrap"] svg': {
    overflow: 'hidden',
    pointerEvents: 'none',
    color: 'currentColor',
    verticalAlign: 'bottom',
    width: "var(--ds-space-200, 16px)",
    height: "var(--ds-space-200, 16px)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
  '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-checked-icon], [data-prosemirror-node-name="blockTaskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-checked-icon]': {
    display: 'none'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
  '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-unchecked-icon], [data-prosemirror-node-name="blockTaskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-unchecked-icon]': {
    display: 'inline'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:checked + span [data-component=checkbox-checked-icon], [data-prosemirror-node-name="blockTaskItem"] input[type=checkbox]:checked + span [data-component=checkbox-checked-icon]': {
    display: 'inline'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:checked + span [data-component=checkbox-unchecked-icon], [data-prosemirror-node-name="blockTaskItem"] input[type=checkbox]:checked + span [data-component=checkbox-unchecked-icon]': {
    display: 'none'
  }
}, "[data-prosemirror-node-name=\"taskItem\"] .".concat(TaskDecisionSharedCssClassName.TASK_CHECKBOX_CONTAINER, ", [data-prosemirror-node-name=\"blockTaskItem\"] .").concat(TaskDecisionSharedCssClassName.TASK_CHECKBOX_CONTAINER), {
  flex: '0 0 24px',
  width: '24px',
  height: '24px',
  position: 'relative',
  alignSelf: 'start',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  "& > input[type='checkbox']": {
    width: '16px',
    height: '16px',
    zIndex: 1,
    cursor: 'pointer',
    outline: 'none',
    margin: 0,
    opacity: 0,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[disabled]': {
      cursor: 'default'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '+ span': {
      width: '24px',
      height: '24px',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '+ span > svg': {
      boxSizing: 'border-box',
      display: 'inline',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      maxWidth: 'unset',
      maxHeight: 'unset',
      position: 'absolute',
      overflow: 'hidden',
      color: "var(--ds-background-input, #FFFFFF)",
      transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
      'path:first-of-type': {
        visibility: 'hidden'
      },
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
      'rect:first-of-type': {
        stroke: "var(--ds-border-input, #8590A2)",
        strokeWidth: 1,
        transition: 'stroke 0.2s ease-in-out'
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&:hover + span > svg': {
      color: "var(--ds-background-input-hovered, #F7F8F9)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
      'rect:first-of-type': {
        stroke: "var(--ds-border-input, #8590A2)"
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&:checked:hover + span > svg': {
      color: "var(--ds-background-selected-bold-hovered, #0055CC)",
      fill: "var(--ds-icon-inverse, #FFFFFF)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
      'rect:first-of-type': {
        stroke: "var(--ds-background-selected-bold-hovered, #0055CC)"
      }
    },
    '&:checked': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
      '+ span > svg': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'path:first-of-type': {
          visibility: 'visible'
        },
        color: "var(--ds-background-selected-bold, #0C66E4)",
        fill: "var(--ds-icon-inverse, #FFFFFF)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
          stroke: "var(--ds-background-selected-bold, #0C66E4)"
        }
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + span > svg': {
      color: "var(--ds-background-input-pressed, #FFFFFF)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
      'rect:first-of-type': {
        stroke: "var(--ds-border, #091E4224)"
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + span > svg': {
      color: "var(--ds-background-input-pressed, #FFFFFF)",
      fill: "var(--ds-icon-inverse, #FFFFFF)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
      'rect:first-of-type': {
        stroke: "var(--ds-border, #091E4224)"
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + span > svg, &:disabled:hover + span > svg, &:disabled:focus + span > svg, &:disabled:active + span > svg': {
      color: "var(--ds-background-disabled, #091E4208)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
      'rect:first-of-type': {
        stroke: "var(--ds-background-disabled, #091E4208)"
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + span > svg': {
      fill: "var(--ds-icon-disabled, #091E424F)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:focus + span::after': {
      position: 'absolute',
      width: "var(--ds-space-200, 16px)",
      height: "var(--ds-space-200, 16px)",
      border: "2px solid ".concat("var(--ds-border-focused, #388BFF)"),
      borderRadius: "var(--ds-space-050, 4px)",
      content: "''",
      display: 'block',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }
  }
}));